import { type ComponentType, createElement, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { ClientSignInLayout } from '@/components/AppLayoutClientSignIn';
import { LoadingFallback } from '@/components/LoadingFallback';

import { initI18n, transformLocales } from '@/helpers/client';

import { CLIENT_APP_LOCALES_LIST } from '@/constants';

import { QueryProvider } from '@/providers';

import * as clientLocalization from '@/client_localization';

import * as LazyClientPages from '@/pages/client/lazy';

export const renderClientSignIn = (
  pageContainer = document.getElementById('page-content'),
  mainInfo = document.getElementById('main-info'),
  renderContainer = document.getElementById('page-root'),
) => {
  if (!pageContainer || !mainInfo || !renderContainer) {
    console.error('Required DOM elements not found');
    return;
  }

  const { component_name, ...pageProps } = JSON.parse(
    pageContainer.getAttribute('data') || '{}',
  );

  const commonData = JSON.parse(mainInfo.getAttribute('data') || '{}');

  const locales = transformLocales(
    [
      clientLocalization.COMMON,
      clientLocalization.validation,
      clientLocalization[component_name as keyof typeof clientLocalization],
    ],
    CLIENT_APP_LOCALES_LIST,
  );

  initI18n(locales, commonData.locale);

  const LazyClientPage = LazyClientPages[
    component_name as keyof typeof LazyClientPages
  ] as ComponentType<unknown> | undefined;

  if (!LazyClientPage) {
    console.error(`Component "${component_name}" not found`);
    return;
  }

  createRoot(renderContainer).render(
    <QueryProvider>
      <ClientSignInLayout commonData={commonData}>
        <Suspense fallback={<LoadingFallback />}>
          {createElement(LazyClientPage, pageProps)}
        </Suspense>
      </ClientSignInLayout>
    </QueryProvider>,
  );
};
